import { useGlobalStore } from '~/stores/global';
import { logger } from '~/api/loggerLogic';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!import.meta.env.SSR && to?.path !== from?.path) {
    const { isDesktop } = useDevice();
    const globalStore = useGlobalStore();
    globalStore.setTypePageFrom(
      String(globalStore.seoData?.page?.type || from.name)
    );
    await globalStore.getPageEnvironment({
      route: to,
      url: window.location.host,
      isRouting: true,
      isDesktop,
    });
  }
});
